<h2 class="row space-between align-center">
  <div>
    @if(isNew){
    <span>New</span>
    }@else{
    <span>Edit</span>
    } Tag
  </div>
  <rr-badge [icon]="tagForm.value.icon" [tone]="group.colorClass">{{
    tagForm.value.name || "your tag-name"
  }}</rr-badge>
</h2>
<form [formGroup]="tagForm" (ngSubmit)="onSubmit()" class="col gap-16 w100">
  <rr-input formControlName="name" label="Name of Tag"></rr-input>
  <div class="col gap-4">
    <span class="color-strong row space-between w100"
      >Select Icon
      <rr-btn type="link" (click)="clearIcon($event)">clear Icon</rr-btn>
    </span>
    <div class="iconarea row">
      @for(icon of iconList; track icon){
      <rr-icon [name]="icon" (click)="selectIcon(icon)"></rr-icon>
      }
    </div>
  </div>
  <div class="row gap-8 align-end w100 justify-end">
    <rr-btn (click)="cancel($event)">Cancel</rr-btn>
    <rr-btn type="Primary">Save</rr-btn>
  </div>
</form>
